<template>
    <button
        class="w-full border-none text-gray-700 font-normal text-left hover:bg-indigo-100 hover:text-indigo-600 block px-4 py-2 text-sm transition duration-150"
        :class="{'text-gray-600 hover:text-gray-600 hover:bg-white' : disable}"
        @click="$emit('click', value);"
        :value="value"
        role="menuitem"
        tabindex="-1"
        :disabled="disable"
        id="id">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "TailwindSimpleDropdownOption",
    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        disable: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            required: true,
            description: "Allows v-model to work"
        }
    },
};
</script>

<style scoped>

</style>
